import { render, staticRenderFns } from "./SupporterAddAddress.vue?vue&type=template&id=3280ff8e&"
import script from "./SupporterAddAddress.vue?vue&type=script&lang=js&"
export * from "./SupporterAddAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports